import apiService from './api';

export const { list } = apiService('/exchange-rates');
